export const featuresMenu = [
  {
    titleKey: "features.studio.title",
    items: [
      { labelKey: "features.studio.haircut" },
      { labelKey: "features.studio.makeup" },
      { labelKey: "features.studio.nails" },
    ],
  },
  {
    titleKey: "features.business.title",
    items: [
      { labelKey: "features.business.bookings" },
      { labelKey: "features.business.clients" },
      { labelKey: "features.business.barbers" },
    ],
  },
  {
    titleKey: "features.operations.title",
    items: [
      { labelKey: "features.operations.inventory" },
      { labelKey: "features.operations.qr_generator" },
      { labelKey: "features.operations.crm" },
    ],
  },
];
